export default [
    {
        element: 'masterid',
        value: 'master-id',
        default: '',
    },

    {
        element: 'item',
        value: 'style-code',
        default: '',
    },
    {
        element: 'orientation',
        value: 'special-orientation',
        default: '',
    },
    {
        element: 'putter-length',
        value: 'special-length',
        default: '',
    },

    {
        element: 'shaft-id',
        value: 'shaft-id',
        default: '',
    },
    {
        element: 'grip-id',
        value: 'grip-id',
        default: '',
    },

    {
        element: 'club-loft-adjustment',
        value: 'loft',
        default: '',
    },
    {
        element: 'club-loft-adjustment-label',
        value: 'loft-label',
        default: '',
    },

    {
        element: 'club-lean-adjustment',
        value: 'lean',
        default: '',
    },
    {
        element: 'club-lean-adjustment-label',
        value: 'lean-label',
        default: '',
    },

    {
        element: 'club-lie-adjustment',
        value: 'lie',
        default: '',
    },
    {
        element: 'club-lie-adjustment-label',
        value: 'lie-label',
        default: '',
    },

    {
        element: 'putter-weight-adjustment',
        value: 'weight',
        default: '',
    },
    {
        element: 'putter-weight-adjustment-label',
        value: 'weight-label',
        default: '',
    },

    {
        element: 'putter-pers-logo',
        value: 'stamp',
        default: '',
    },

    {
        element: 'putter-pers-logo-label',
        value: 'stamp-label',
        default: '',
    },

    {
        element: 'putter-pers-logo-color',
        value: 'stamp-color',
        default: '',
    },

    {
        element: 'putter-pers-logo-color-label',
        value: 'stamp-color-label',
        default: '',
    },

    {
        element: 'putter-pers-shaft-band',
        value: 'putter-shaft-band',
        default: '',
    },

    {
        element: 'putter-pers-shaft-band-label',
        value: 'putter-shaft-band-label',
        default: '',
    },

    {
        element: 'putter-pers-initials-color',
        value: 'initials-color',
        default: '',
    },

    {
        element: 'putter-pers-initials-color-label',
        value: 'initials-color-label',
        default: '',
    },

    {
        element: 'putter-pers-initials-style',
        value: 'initials-style',
        default: '',
    },

    {
        element: 'putter-pers-initials-style-label',
        value: 'initials-style-label',
        default: '',
    },

    {
        element: 'putter-pers-initials',
        value: 'initials',
        default: '',
    },

    {
        element: 'preview',
        value: 'special-preview',
        default: '',
    },
    {
        element: 'recipe',
        value: 'special-recipe',
        default: '',
    },

    {
        element: 'headcover-id',
        value: 'headcover-id',
        default: '',
    },

    {
        element: 'headcover-label',
        value: 'headcover-label',
        default: '',
    },

    {
        element: 'putter-pers-toe-weight-color',
        value: 'putter-pers-toe-weight-color',
        default: '',
    },
    {
        element: 'putter-pers-toe-weight-color-label',
        value: 'putter-pers-toe-weight-color-label',
        default: '',
    },

    {
        element: 'putter-pers-heel-weight-color',
        value: 'putter-pers-heel-weight-color',
        default: '',
    },
    {
        element: 'putter-pers-heel-weight-color-label',
        value: 'putter-pers-heel-weight-color-label',
        default: '',
    },

    {
        element: 'putter-pers-sole-crown-color',
        value: 'putter-pers-sole-crown-color',
        default: '',
    },
    {
        element: 'putter-pers-sole-crown-color-label',
        value: 'putter-pers-sole-crown-color-label',
        default: '',
    },

    {
        element: 'putter-pers-face-logo-color',
        value: 'putter-pers-face-logo-color',
        default: '',
    },
    {
        element: 'putter-pers-face-logo-color-label',
        value: 'putter-pers-face-logo-color-label',
        default: '',
    },

    {
        element: 'putter-pers-sole-crown-color',
        value: 'putter-pers-sole-crown-color',
        default: '',
    },
    {
        element: 'putter-pers-sole-crown-color-label',
        value: 'putter-pers-sole-crown-color-label',
        default: '',
    },

    {
        element: 'putter-pers-sole-scotty-color',
        value: 'putter-pers-sole-scotty-color',
        default: '',
    },
    {
        element: 'putter-pers-sole-scotty-color-label',
        value: 'putter-pers-sole-scotty-color-label',
        default: '',
    },

    {
        element: 'putter-pers-sole-family-color',
        value: 'putter-pers-sole-family-color',
        default: '',
    },
    {
        element: 'putter-pers-sole-family-color-label',
        value: 'putter-pers-sole-family-color-label',
        default: '',
    },

    {
        element: 'putter-pers-sole-model-color',
        value: 'putter-pers-sole-model-color',
        default: '',
    },
    {
        element: 'putter-pers-sole-model-color-label',
        value: 'putter-pers-sole-model-color-label',
        default: '',
    },

    {
        element: 'putter-pers-top-line-color',
        value: 'putter-pers-top-line-color',
        default: '',
    },
    {
        element: 'putter-pers-top-line-color-label',
        value: 'putter-pers-top-line-color-label',
        default: '',
    },

    {
        element: 'putter-pers-back-milled-color',
        value: 'putter-pers-back-milled-color',
        default: '',
    },
    {
        element: 'putter-pers-back-milled-color-label',
        value: 'putter-pers-back-milled-color-label',
        default: '',
    },

    {
        element: 'putter-pers-back-dot-heel-color',
        value: 'putter-pers-back-dot-heel-color',
        default: '',
    },
    {
        element: 'putter-pers-back-dot-heel-color-label',
        value: 'putter-pers-back-dot-heel-color-label',
        default: '',
    },

    {
        element: 'putter-pers-back-dot-center-color',
        value: 'putter-pers-back-dot-center-color',
        default: '',
    },
    {
        element: 'putter-pers-back-dot-center-color-label',
        value: 'putter-pers-back-dot-center-color-label',
        default: '',
    },

    {
        element: 'putter-pers-back-dot-toe-color',
        value: 'putter-pers-back-dot-toe-color',
        default: '',
    },
    {
        element: 'putter-pers-back-dot-toe-color-label',
        value: 'putter-pers-back-dot-toe-color-label',
        default: '',
    },
];
